<div *ngIf="visible" class="layer" (click)="layerClicked()">
  <div class="box" [innerHTML]="text">
  </div>
</div>
